import type { ApiClient } from "@/clients/ApiClient";
import { fromEither } from "./compat";

export interface CollectionsApi {
    list(): Promise<Collection[]>;
    /** Throws when there is no such (public) collection */
    bySlug(slug: string): Promise<Collection>;
    episodes(id: number, page: number): Promise<Episode[]>;
}

// The Go API leaves out empty text fields, the pages read them as strings
const normalize = (collection: Collection): Collection => ({
    ...collection,
    content: collection.content ?? "",
    podcasts: collection.podcasts ?? [],
});

export const createCollectionsApi = (client: ApiClient): CollectionsApi => ({
    async list() {
        return fromEither<Collection[]>(await client.get("/collections"), "collections").map(normalize);
    },

    async bySlug(slug) {
        const collection = fromEither<Collection | null>(
            await client.get(`/collections/bySlug/${encodeURIComponent(slug)}`),
            "collection"
        );
        if (!collection) {
            throw new Error(`Collection not found: ${slug}`);
        }
        return normalize(collection);
    },

    async episodes(id, page) {
        return fromEither<Episode[]>(await client.get(`/collections/${id}/episodes?page=${page}`), "episodes");
    },
});
